export const timeAgo = (timestamp: string | number) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const oneWeek = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

  // For very recent timestamps (less than 24 hours)
  if (diff < 60000) return `${Math.floor(diff / 1000)} seconds ago`;
  if (diff < 3600000) return `${Math.floor(diff / 60000)} minutes ago`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)} hours ago`;

  // For dates within the week: 'Tue 9:40 PM'
  if (diff < oneWeek) {
    return (
      date.toLocaleDateString(undefined, {
        weekday: 'short',
      }) +
      ' ' +
      date.toLocaleTimeString(undefined, {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
    );
  }

  // For older dates: 'May 23, 2025, 6:45 AM'
  return (
    date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }) +
    ', ' +
    date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
  );
};
